import { getEndpoint } from '../endpoints';
import { commonFields } from '../../utils/commonFields';
import { vptSpecifcFields } from '../../utils/vptSpecifcFields';
import { attachmentFields } from '../../utils/attachmentFields';

export const vpt = {
    state: {
        vptForm: {
            ...commonFields,
            ...vptSpecifcFields,
            ...attachmentFields,
        },
    },
    getters: {
        getVptForm(state) {
            return state.vptForm;
        },
    },
    actions: {
        async getRequestVptById({ rootState, commit, dispatch }) {
            const { controlId: reqControlId, propertyId: reqPropertyId } = rootState.route.params;
            const storedControlId = (rootState.refControls.controls[0] || {}).id || null;
            const storedPropertyId = rootState.refProperties.property.id || null;
            const setControl = (controlId) => {
                const control = rootState.refControls.controls.find(
                    value => value.id === controlId
                );

                if (!control) {
                    return;
                }

                commit('setControl', control);
                commit('setVptForm', control.data);
            };

            const needToRefetch = reqControlId !== storedControlId || reqPropertyId !== storedPropertyId;

            if (needToRefetch) {
                dispatch('fetchProperty', { id: rootState.route.params.propertyId });
                dispatch('setIdProperty', { id: rootState.route.params.propertyId });
                dispatch('fetchControls', { id: rootState.route.params.propertyId }).then(() => {
                    setControl(reqControlId);
                });

                return;
            }

            setControl(reqControlId);
        },
        async submitVpt({ rootState, dispatch, state, commit }, payload) {
            let formData = new FormData();
            const endpoint = getEndpoint(rootState.app.typeForm, null, rootState.route.params.controlId)[
                payload.action
            ];
            commit('addExtratFieldsToForm', { property: rootState.refProperties.property });

            Object.entries(state.vptForm).map(([key, values]) => {
                var exisitingFiles = [];
                if (Array.isArray(values)) {
                    values.forEach((fileElement, index) => {
                        if (fileElement instanceof File) {
                            formData.append(key + '[' + index + ']', fileElement);
                        } else if (fileElement) {
                            delete fileElement.manuallyAdded;
                            delete fileElement._removeLink;
                            exisitingFiles.push(fileElement);
                        }
                    });
                    state.vptForm[key] = exisitingFiles.slice();
                }
            });

            if (state.vptForm.signature && !state.vptForm.signature.startsWith('data:')) {
                state.vptForm.signature = null;
            }
            state.vptForm.folderNumberLong = rootState.refProperties.property.folderNumberLong;
            formData.append('data', JSON.stringify(state.vptForm));
            dispatch('postFormRoute', { endpoint, form: formData });
        },
        handleSubmitVpt({ dispatch }) {
            dispatch('submitVpt', { action: `create` });
        },
        handleSubmitEditVpt({ dispatch }) {
            dispatch('submitVpt', { action: `edit` });
        },
        initVptForm({ commit }) {
            commit('initVptForm');
        },
    },
    mutations: {
        setVptForm(state, payload) {
            Object.entries(payload).map(([key, val]) => {
                if (val && typeof val === 'object' && val.constructor === Object) {
                    if (typeof val.id !== 'undefined') {
                        payload[key] = val.id;
                    }
                }
            });
            state.vptForm = payload;
        },
        initVptForm(state) {
            state.vptForm = { ...commonFields, ...vptSpecifcFields, ...attachmentFields };
        },
        addExtratFieldsToForm(state, payload) {
            state.vptForm.property = payload.property;
            state.vptForm.user = null;

            if (state.vptForm.contact !== null && state.vptForm.contact.id !== null) {
                var contact = state.vptForm.property.contacts.find(function (contact) {
                    return contact.id == state.vptForm.contact;
                });
                state.vptForm.contact = new Object();
                state.vptForm.contact.id = contact.id;
                state.vptForm.contact.address = `${contact.numberStreet} ${contact.zipCode} ${contact.town}`;
                state.vptForm.contact.email = contact.email;
                state.vptForm.contact.firstName = contact.firstName;
                state.vptForm.contact.lastName = contact.name;
                state.vptForm.contact.mobileNumber = contact.mobilePhone;
                state.vptForm.contact.phoneNumber = contact.fixedLinePhone;
            }
        },
    },
};
